/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@jira/software__capacity/src/__generated__/CapacityWorkViewContentQuery$parameters.ts';
import type { CapacityWorkViewContentQuery as WorkViewContentQueryType } from '@jira/software__capacity/src/__generated__/CapacityWorkViewContentQuery.graphql.ts';

type WorkQueries = { capacityData: WorkViewContentQueryType };

type CapacityWorkEntryPointComponent = EntryPointComponent<
	WorkQueries,
	{},
	{},
	{
		tenantContext: TenantContext;
	}
>;

export const capacityWorkEntryPoint: EntryPoint<
	CapacityWorkEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<CapacityWorkEntryPointComponent>(
		/* webpackChunkName: "async-jira-capacity-work" */ './SoftwareCapacityWorkEntryPoint.tsx',
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		const {
			context: { match },
			tenantContext,
		} = entryPointRouteParams;

		const boardId = match.params.boardId;
		if (!boardId) {
			throw new Error('boardId is required for capacity work view');
		}

		const sourceAri = `ari:cloud:jira-software:${tenantContext.cloudId}:board/${boardId}`;

		return {
			queries: {
				capacityData: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						id: sourceAri,
					},
				},
			},
			entryPoints: {},
			extraProps: {
				tenantContext,
				sourceAri,
			},
		};
	},
});
